import React from 'react';
import { Button } from '@material-ui/core';
import useConfirmationDialog from '../../../../../../../../components/useConfirmationDialog/UseConfirmationDialog';
import RegistrationService from '../../../../../../../../services/main/Registration.service';
import { EmptyVoidFunction } from '../../../../../../../../utils/types/Types';
import Toasters from '../../../../../../../../components/popUp/PopUp';
import useTranslation from '../../../../../../../../components/localization/customHooks/Translation';

const TransferToAwaitingParticipants = (props: {
  participantId: number | null;
  fetchAllParticipants: EmptyVoidFunction;
}) => {
  const { participantId, fetchAllParticipants } = props;
  const l10n = useTranslation();
  const { Dialog, onOpen, onClose } = useConfirmationDialog({
    headerText: l10n.components.headerLabel.CANCEL_REGISTRATION,
    bodyText: l10n.components.confirmDialogsMessage.CANCEL_REGISTRATION,
    confirmationButtonText: l10n.components.button.CONTINUE,
    onConfirmClick: async () => {
      if (participantId) {
        const res = await RegistrationService.transferToAwaitingParticipants(participantId);
        if (res) {
          Toasters.success(l10n.components.toasterMessage.PARTICIPANT_HAS_BEEN_ADDED_TO_WAITLIST);
        }
      }
      onClose();
      fetchAllParticipants();
    },
  });

  return (
    <>
      <Button variant="outlined" color="primary" onClick={() => onOpen()}>
        {l10n.components.button.CANCEL_REGISTRATION}
      </Button>
      <Dialog />
    </>
  );
};

export default TransferToAwaitingParticipants;
